export { default as CaChatPanel } from './widgets/CaChatPanel/CaChatPanel'
export type { CaChatPanelProps } from './widgets/CaChatPanel/CaChatPanel'
// Dashboard "your account" card — surfaces the user id to paste into the share dialog.
export { default as AccountIdentityWidget } from './features/account-identity/AccountIdentityWidget'
export { createCaApiClient } from './shared/CaApiClient'
export { CA_CHAT_PERMISSIONS } from './shared/permissions'
export type { CaApiClient, ConversationMeta, Turn, CaReply, TableData, VegaSpec, ChartPayload } from './shared/types'
